import { JourneyMascots } from "../components/JourneyMascots";
import { Landing } from "./Landing";

/**
 * Animated landing: same big illustrations as `/`, but each one pins to the
 * centre of the viewport while its section is visible (`position: sticky`),
 * and three small running mascots cross the background between sections to
 * carry the journey forward.
 *
 * Wiring:
 *  - Landing in `transparent` mode → section backgrounds are see-through so
 *    the mini running mascots in JourneyMascots are visible behind text.
 *  - Landing in `hideInlineMascots` mode → keeps inline illustrations, but
 *    pins each NarrativeSection's mascot column to viewport centre while
 *    its parent section scrolls past, and adds a final MascotScene + a
 *    `data-mascot-stop="cta"` anchor inside the CTA section.
 *  - JourneyMascots reads `data-mascot-stop` anchors from the page (hero,
 *    scene-1..4, cta) and runs three mini mascots between them; minis are
 *    only visible during the "running" portion of each leg — once parked
 *    next to a big illustration they fade out and the big one carries on.
 */
export function LandingV2() {
  return (
    <div className="relative nf-journey">
      <JourneyMascots />

      <div style={{ position: "relative", zIndex: 1 }}>
        <Landing transparent hideInlineMascots />
      </div>

      {/* Only the active illustration is visible at any moment; the rest are
          opacity 0. Crossfade ~500ms when JourneyMascots flips data-active to
          the next stop. The animation on the SVG (not on [data-mascot-stop]
          itself) keeps it from clobbering CSS sticky's transform. */}
      <style>{`
        .nf-journey [data-mascot-stop] {
          opacity: 0;
          transition: opacity 500ms ease;
        }
        .nf-journey [data-mascot-stop][data-active] {
          opacity: 1;
        }
        .nf-journey [data-mascot-stop][data-active] > svg,
        .nf-journey [data-mascot-stop][data-active] > div > svg {
          animation: nfActiveBob 4s ease-in-out infinite;
        }
        @keyframes nfActiveBob {
          0%, 100% { transform: translateY(0); }
          50%      { transform: translateY(-5px); }
        }
        @media (prefers-reduced-motion: reduce) {
          .nf-journey [data-mascot-stop] {
            opacity: 1;
            transition: none;
          }
          .nf-journey [data-mascot-stop][data-active] > svg,
          .nf-journey [data-mascot-stop][data-active] > div > svg {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
